export default __webpack_public_path__ + "static/media/BookQuest4.226c806f.jpg";